var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.7 296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#ccc;}.cls-3{fill:#1b1464;}.cls-4{fill:#95a5a6;}.cls-5{fill:#bdc3c7;}.cls-6{fill:#eceff1;}.cls-7{fill:#388e3c;}.cls-8{fill:#2e7d32;}.cls-9{fill:#fafafa;}.cls-10{fill:#2a5699;}.cls-11{fill:#fff;}.cls-12{fill:#ebebeb;}.cls-13{fill:#a6e2e3;}.cls-14{fill:#ffa638;}.cls-15{fill:#ed8300;}.cls-16{fill:#e9e9e0;}.cls-17{fill:#d9d7ca;}.cls-18{fill:#cc4b4c;}.cls-19{fill:#cee2f2;opacity:0.02;}.cls-20{fill:#006837;}.cls-21{fill:#333;}.cls-22{fill:#34495e;}.cls-23{fill:#009245;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 7PDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.43,114.63C100.06,94.21,45.54,107.69,0,128.36V278.8A17.2,17.2,0,0,0,17.2,296H349.79C308,224.51,228.75,150.89,146.43,114.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.17,231.44C178.09,159.79,101,267.89,101,267.89S82.06,158.39,0,85V274.39C0,286.32,11.2,296,25,296H390.36C394.37,274.63,381,252.33,335.17,231.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.43,265.63s-74,30-169-12-143-49-185-26c-23,12.6-38.51,4.2-52.43-13.22V278.8A17.2,17.2,0,0,0,17.2,296H495.7C461.42,260.58,406.43,265.63,406.43,265.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.71,46.26a6.93,6.93,0,0,0-9.78.07L167.51,66l-9.7,9.85L143.25,90.66a6.91,6.91,0,0,0,.07,9.77l34.48,34a6.94,6.94,0,0,0,9.78-.07l14.56-14.78,9.7-9.85,9.71-9.85-.22-29.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.13,43.79a6.93,6.93,0,0,0-9.78.08l-19.41,19.7-9.71,9.85L145.67,88.19a6.94,6.94,0,0,0,.08,9.78l34.47,34a6.93,6.93,0,0,0,9.78-.08l14.56-14.77,9.71-9.85L224,97.4l-.21-29.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224,97.4l-.21-29.34-9.71,9.85a6.93,6.93,0,0,0,.07,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.61,63.46l-2.43,2.46L211.73,95l2.43-2.46Zm-7.28,7.39-2.43,2.46,29.55,29.12,2.43-2.46Zm-7.28,7.38-2.43,2.47,29.55,29.12,2.43-2.47Zm-7.28,7.39-2.43,2.47,29.55,29.12,2.43-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.38,95.55l-35.07-8.84a2.59,2.59,0,0,1-1.87-3.14l12.63-50.1a2.58,2.58,0,0,1,3.14-1.88l35.07,8.85a2.57,2.57,0,0,1,1.87,3.13l-12.63,50.1A2.58,2.58,0,0,1,185.38,95.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M170.44,49.15l-10-2.53a2.58,2.58,0,1,1,1.26-5l10,2.53a2.58,2.58,0,0,1-1.26,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.91,59.17l-10-2.53a2.58,2.58,0,0,1,1.26-5l10,2.53a2.58,2.58,0,0,1-1.27,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M165.39,69.19l-10-2.52a2.58,2.58,0,1,1,1.26-5l10,2.52a2.58,2.58,0,0,1-1.26,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.86,79.21l-10-2.52a2.58,2.58,0,0,1,1.26-5l10,2.52a2.58,2.58,0,1,1-1.26,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M185.47,52.94l-5-1.26a2.58,2.58,0,0,1,1.26-5l5,1.26a2.58,2.58,0,1,1-1.26,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M182.94,63l-5-1.26a2.58,2.58,0,0,1,1.27-5l5,1.26a2.58,2.58,0,0,1-1.27,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M180.42,73l-5-1.26a2.58,2.58,0,1,1,1.26-5l5,1.26a2.58,2.58,0,0,1-1.26,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.89,83l-5-1.26a2.58,2.58,0,0,1,1.26-5l5,1.26a2.58,2.58,0,1,1-1.26,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.19,22.55a2.54,2.54,0,0,0-1.93-1.05l-42-2.59a2.57,2.57,0,0,0-2.66,1.95L107.73,76a2.58,2.58,0,0,0,1.42,3l38.19,17.62a3,3,0,0,0,.45.16,2.59,2.59,0,0,0,3.13-1.88l17.69-70.14A2.59,2.59,0,0,0,168.19,22.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M147,65.47l-5.64-11L152,46.14a2.58,2.58,0,0,0-3.17-4.08L139,49.73,134.53,41a2.58,2.58,0,1,0-4.6,2.35l4.9,9.61-9.24,7.22a2.58,2.58,0,0,0-.46,3.62,2.63,2.63,0,0,0,1.42.92,2.58,2.58,0,0,0,2.22-.47l8.46-6.61,5.18,10.16a2.61,2.61,0,0,0,1.67,1.34A2.58,2.58,0,0,0,147,65.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131.67,72.23,96,78a2.59,2.59,0,0,1-3-2.14l-8.26-51a2.59,2.59,0,0,1,2.13-3l35.71-5.78a2.58,2.58,0,0,1,3,2.13l8.27,51A2.58,2.58,0,0,1,131.67,72.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M116.74,43.83a2.32,2.32,0,0,0-.74-4.59L95.38,42.58,94.63,38l20.62-3.34a2.32,2.32,0,0,0-.74-4.59L93.89,33.39,91.28,17.31a2.31,2.31,0,0,0-1.11-1.63,2.28,2.28,0,0,0-2-.19L52.66,28.32a2.33,2.33,0,0,0-1.5,2.56l8.19,50.55a2.31,2.31,0,0,0,2.23,1.95l37.78,1a1.59,1.59,0,0,0,.43,0,2.25,2.25,0,0,0,1.37-.76,2.27,2.27,0,0,0,.54-1.9L99.1,65.55l20.62-3.34a2.32,2.32,0,0,0-.74-4.59L98.35,61l-.74-4.6L118.23,53a2.32,2.32,0,0,0-.74-4.59L96.86,51.77l-.74-4.6,20.62-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M85.87,42l1.06,21a2.33,2.33,0,0,1-1.67,2.35,1.27,1.27,0,0,1-.28.06,2.32,2.32,0,0,1-2.39-1.14L75.81,52.46,73.13,65.87A2.29,2.29,0,0,1,71,67.74a2.32,2.32,0,0,1-2.34-1.64L63.75,50.39A2.32,2.32,0,1,1,68.18,49l2.18,7,2.11-10.57a2.42,2.42,0,0,1,4.3-.7l5,8.82-.57-11.33A2.32,2.32,0,1,1,85.87,42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "62.91 48.19 50.19 42.85 16.63 77.57 76.08 135.03 122.04 87.48 75.43 42.42 62.91 48.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M65.42,74.19a5.1,5.1,0,1,1,.12,7.22A5.1,5.1,0,0,1,65.42,74.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M75.13,56.19,99,79.24l-31.91,33-23.84-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M65.42,74.19a5.1,5.1,0,1,1,.12,7.22A5.1,5.1,0,0,1,65.42,74.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "97.14 77.47 107.22 87.22 89.52 105.54 79.75 96.1 81.7 76.92 97.14 77.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "79.75 96.1 95.61 99.24 75.31 120.23 67.06 112.25 64.84 93.15 79.75 96.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.43 42.42 63.02 55.26 50.19 42.85 75.43 42.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M141.09,51.09H96.53c-1.24,0-2.24,1-2.24,3v81.48c0,.53,1,1.53,2.24,1.53h61.53c1.24,0,2.24-1,2.24-1.53V71c0-1.06-.14-1.41-.39-1.66L142,51.48A1.34,1.34,0,0,0,141.09,51.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "141.88 51.32 141.88 69.51 160.07 69.51 141.88 51.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M114.27,102.25h0a2.45,2.45,0,0,1-1.49-.5,3.67,3.67,0,0,1-1.71-3.44c.28-2.5,3.37-5.12,9.19-7.78A103,103,0,0,0,126.07,74c-1.53-3.33-3-7.66-1.93-10.2A2.93,2.93,0,0,1,125.88,62a7.29,7.29,0,0,1,1.56-.27c.77,0,1.45,1,1.93,1.62s1.48,1.8-.57,10.44a49.11,49.11,0,0,0,7.81,11.61,29.4,29.4,0,0,1,5.16-.55c2.4,0,3.86.56,4.45,1.71.5,1,.29,2.07-.59,3.32a4.09,4.09,0,0,1-3.41,1.83c-1.87,0-4-1.18-6.47-3.51a73.42,73.42,0,0,0-13.55,4.33A43.5,43.5,0,0,1,118.54,99C117,101.22,115.61,102.25,114.27,102.25Zm4.08-7.87c-3.28,1.84-4.62,3.36-4.71,4.21,0,.14-.06.52.66,1.07C114.53,99.58,115.86,99,118.35,94.38Zm20.94-6.82c1.25,1,1.56,1.45,2.37,1.45a2.29,2.29,0,0,0,1.86-.68,2.66,2.66,0,0,0,.36-.63c-.19-.1-.44-.31-1.81-.31A24.78,24.78,0,0,0,139.29,87.56Zm-11.47-10.1a113,113,0,0,1-4.1,11.61,75.46,75.46,0,0,1,10-3.1A52.93,52.93,0,0,1,127.82,77.46Zm-.93-13A3.69,3.69,0,0,0,127,69.4C128.49,66.15,127,64.44,126.89,64.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M158.06,137.06H96.53a2.24,2.24,0,0,1-2.24-2.24V111h66v23.86A2.24,2.24,0,0,1,158.06,137.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M111,132.46h-2.52V117h4.45a6.3,6.3,0,0,1,1.95.31,5.31,5.31,0,0,1,1.73,1,5.08,5.08,0,0,1,1.24,1.52,4.25,4.25,0,0,1,.47,2,5.44,5.44,0,0,1-.4,2.14,4.34,4.34,0,0,1-1.11,1.6,5.15,5.15,0,0,1-1.72,1,6.6,6.6,0,0,1-2.23.36H111v5.58Zm0-13.56V125h2.31a2.65,2.65,0,0,0,.91-.16,2.33,2.33,0,0,0,.83-.51,2.62,2.62,0,0,0,.61-1,4.86,4.86,0,0,0,.23-1.59,4.3,4.3,0,0,0-.11-.87,2.49,2.49,0,0,0-.43-.94,2.66,2.66,0,0,0-.91-.76,3.42,3.42,0,0,0-1.55-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M133.77,124.29a11.48,11.48,0,0,1-.41,3.27,8.1,8.1,0,0,1-1,2.27,5.22,5.22,0,0,1-1.42,1.43,6.72,6.72,0,0,1-1.52.79,6,6,0,0,1-1.34.34c-.41,0-.71.07-.9.07h-5.86V117h4.66a8.86,8.86,0,0,1,3.43.62,7,7,0,0,1,2.46,1.65,6.64,6.64,0,0,1,1.46,2.34A7.75,7.75,0,0,1,133.77,124.29Zm-7.47,6.32A4.15,4.15,0,0,0,130,129a9.66,9.66,0,0,0,.91-6.66,4.16,4.16,0,0,0-.9-1.71,4.8,4.8,0,0,0-1.79-1.24,7.87,7.87,0,0,0-2.94-.47H123.8v11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M140,118.9v4.87h6.47v1.72H140v7h-2.56V117h9.68v1.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 154.14,
    y: 91.69,
    width: 48.62,
    height: 47.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "187.2 100.43 178.45 91.96 169.69 100.43 171.25 101.75 177.47 95.72 177.47 116.42 179.42 116.42 179.42 95.72 185.64 101.75 187.2 100.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M193,103.92H181.36v1.88h10.51L200.42,119H187.2v3.76a3.84,3.84,0,0,1-3.89,3.76h-9.73a3.83,3.83,0,0,1-3.88-3.76V119H156.47L165,105.8h10.5v-1.88H163.86l-9.72,15V135.9h48.62V119Zm7.78,30.1H156.08V120.85h11.67v2.82a4.74,4.74,0,0,0,4.86,4.71h11.67a4.74,4.74,0,0,0,4.86-4.71v-2.82h11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M156.08,120.85V134h44.73V120.85H189.14v2.82a4.74,4.74,0,0,1-4.86,4.71H172.61a4.74,4.74,0,0,1-4.86-4.71v-2.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "145.64 36.39 155.34 23.36 163.22 40.3 195.25 0 201.16 9.6 206.75 18.7 160.92 49.47 145.64 36.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "162.83 44.05 202.68 12.08 206.75 18.7 160.92 49.47 145.64 36.39 150.69 29.6 162.83 44.05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg4);
export default __webpack_public_path__ + "static/media/BG_4.701b246e6764a979f0749725ebc1ae1a.svg";
export { ForwardRef as ReactComponent };